module.exports = __webpack_public_path__ + "img/autocolante.858b9aec.svg";